import { render } from "./add_platform_config.html?vue&type=template&id=4e0edc4e&external"
import script from "./add_platform_config.js?vue&type=script&lang=js&external"
export * from "./add_platform_config.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__